import {isNotUndefined} from '@yandex-delivery/utils'
import {array, boolean, number, object, string} from 'yup'

export const OfferCalculate = object({
  routePoints: array(
    object({
      lon: number().required(),
      lat: number().required(),
    }).required(),
  )
    .min(2)
    .required(),
  items: array(
    object({
      currency: string().optional().notRequired(),
      cost: string().optional().notRequired(),
      title: string().optional().notRequired(),
      weight: number().optional().default(undefined).notRequired(),
      size: object({
        width: number().notRequired(),
        height: number().notRequired(),
        length: number().notRequired(),
      }),
      sourcePointId: number().notRequired(),
      destinationPointId: number().notRequired(),
    }).notRequired(),
  ).notRequired(),
  tariffRequirements: object({
    taxi_class: array().of(string().required()).min(1).required(),
    cargo_type: string().notRequired(),
    cargo_loaders: number().notRequired(),
    cargo_options: array(string()).notRequired(),
    pro_courier: boolean().notRequired(),
    assign_robot: boolean().notRequired(),
    skip_door_to_door: boolean().notRequired(),
    due: string().notRequired(),
  }).required(),
  paymentInfo: object({
    type: string().required(),
    method: string().required(),
    methodId: string().notRequired(),
  }).optional(),
}).test('route-points-items-check', 'Route points must be one more than items', function ({routePoints, items}) {
  const maxDropOffPointIndex = items
    ? Math.max(...items.map(item => item.destinationPointId).filter(isNotUndefined))
    : 0

  return !!routePoints?.[maxDropOffPointIndex]
})
